var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-dialog", {
    attrs: { "max-width": "600" },
    scopedSlots: _vm._u(
      [
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [_vm._t("activator", null, { on: on })]
          },
        },
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "v-card",
                [
                  _c("v-toolbar", { attrs: { color: "primary", dark: "" } }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _c("v-card-text", [
                    _c("div", { staticClass: "text-body-1 pt-6" }, [
                      _vm._v(_vm._s(_vm.message)),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-end" },
                    [
                      _c(
                        "v-btn",
                        { attrs: { text: "" }, on: { click: _vm.handleClose } },
                        [_vm._v("Close")]
                      ),
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            attrs: {
                              text: "",
                              color: "primary",
                              loading: _vm.loading,
                            },
                          },
                          _vm.listeners
                        ),
                        [_vm._v(" Confirm ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }